import React, { useReducer, useEffect, useState } from "react";
import {
    Box,
    MenuItem,
    InputLabel,
    Select,
    Typography,
    styled,
    Container,
    TextField,
    Autocomplete,
    FormHelperText,
    Grid,
    CircularProgress,
    InputAdornment,
    FormControl
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useNavigate } from "react-router-dom";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import {
    StyledTextField,
    StyledFormControl,
    FormContainer,
    StyledButton,
    FormGrid,
} from "../../common/FormStyles";
import {
    getCitiesList,
    getLocationData,
    getReligionsList,
    getCountriesList,
    getCastesList,
    getMusicList,
    getHobbiesList,
    updatePersonalDetails,
    getMotherTongueList,
    getStarList,
    getMoonsignList,
    getInterestsList,
    getCuisineList,
    getReadsList,
    getSportsList,
    getMoviesList,
    getDressStyleList,
    getLanguageList,
    getApplicationForList,
    getSourceList,
    getNearestBranchList,
    getProfileDetails,
    getHealthConditionList,
    getSubCatesList,
    getCitiesListByCountry
} from "../../../services/operations/userOperations";
import CustomAlert from "../../common/CustomAlert";
import dayjs from "dayjs";
import { setFormData, getFormData } from "../../../utils/localStorageManager";
import PhoneInput from "react-phone-input-2";
import utc from 'dayjs/plugin/utc';

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: "600",
    fontSize: "16px",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: "#333333",
}));

const initialState = {
    fullName: "",
    surname: "",
    email: "",
    mobileNumber: "",
    gender: "",
    address: "",
    dateOfBirth: new Date(
        new Date().setFullYear(new Date().getFullYear() - 18)
      ),
    timeOfBirth: dayjs(),
    birthPlace: "",
    country : null,
    religion: null,
    city:null,
    subcaste: null,
    caste: null,
    contrys:null,
    convertedCaste: null, // Changed from boolean to number
    gothram: "",
    khujaDosham: null,
    height: "",
    bloodGroup: "",
    motherTongue: "",
    healthCondition: null, // Changed from string to number
    complexion: "",
    maritalStatus: "",
    smoke: "",
    drink: "",
    food: "",
    selectedMusic: null,
    selectedHobbies: [],
    selectedLocation: {
        cityId: null,
        cityName: "",
        districtName: "",
        stateName: "",
        countryName: "",
        countryId: null,
        stateId: null,
        districtId: null,
    },
    aadharNumber: "",
    star: null,
    moonsign: null,
    handicappedInfo: "",
    havingChildren: 0,
  noOfChildren: 0,
  childrenInfo: [],
    dateOfMarriage: dayjs(),
    dateOfDeath: dayjs(),
    dateOfDivorce: dayjs(),
    deathCertificate: null,
    divorceCertificate: null,
    interests: [],
    cuisines: [],
    reads: [],
    sports: [],
    movies: [],
    dressStyles: [],
    reasonForDivorce: "",
    favouriteReads: [],
    spokenLanguages: [],
    alternativeEmail: "",
    pincode: "",
    alternativeMobile: "",
    timeToCall: null,
    applicationFor: null, // Will store the numeric ID
    applicationFillingPersonName: "",
    applicationFillingPersonMobile: "",
    source: null,
    nearestBranch: null,
    errors: {
        fullName: "",
        surname: "",
        email: "",
        mobileNumber: "",
        gender: "",
        dateOfBirth: "",
        timeOfBirth: "",
        birthPlace: "",
        religion: "",
        caste: "",
        subcaste: "",
        country:"",
        convertedCaste: "",
        gothram: "",
        khujaDosham: "",
        height: "",
        bloodGroup: "",
        motherTongue: "",
        healthCondition: "",
        complexion: "",
        maritalStatus: "",
        smoke: "",
        drink: "",
        food: "",
        selectedMusic: "",
        selectedHobbies: "",
        city: "",
        address: "",
        star: "",
        moonsign: "",
        handicappedInfo: "",
        interests: "",
        cuisines: "",
        reads: "",
        sports: "",
        movies: "",
        dressStyles: "",
        spokenLanguages: "",
        applicationFor: "",
        applicationFillingPersonName: "",
        applicationFillingPersonMobile: "",
        source: "",
        nearestBranch: "",
    },
};

const formReducer = (state, action) => {
    switch (action.type) {
        case "SET_FIELD":
            return {
                ...state,
                [action.field]: action.value,
            };
        case "SET_LOCATION":
            return {
                ...state,
                selectedLocation: action.value,
            };
        case "SET_ERRORS":
            return {
                ...state,
                errors: action.errors,
            };
        case "SET_CHILD_INFO":
            const updatedChildren = [...(state.childrenInfo || [])];
            
            if (!updatedChildren[action.index]) {
                updatedChildren[action.index] = { gender: "", age: "", dependentOn: "" };
            }
            
            updatedChildren[action.index][action.field] = action.value;
            
            return {
                ...state,
                childrenInfo: updatedChildren,
            };
        default:
            return state;
    }
};


const PersonalDetailsForm = () => {
    const navigate = useNavigate();
    const [state, dispatch] = useReducer(formReducer, initialState);
    const [cities, setCities] = useState([]);
    const [religions, setReligions] = useState([]);
    const [castes, setCastes] = useState([]);
    const [musicList, setMusicList] = useState([]);
    const [hobbies, setHobbies] = useState([]);
    const [motherTongueList, setMotherTongueList] = useState([]);
    const [starList, setStarList] = useState([]);
    const [moonsignList, setMoonsignList] = useState([]);
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [interestsList, setInterestsList] = useState([]);
    const [cuisineList, setCuisineList] = useState([]);
    const [readsList, setReadsList] = useState([]);
    const [sportsList, setSportsList] = useState([]);
    const [moviesList, setMoviesList] = useState([]);
    const [dressStyleList, setDressStyleList] = useState([]);
    const [languageList, setLanguageList] = useState([]);
    const [applicationForList, setApplicationForList] = useState([]);
    const [sourceList, setSourceList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [healthConditionList, setHealthConditionList] = useState([]);
    const [subcastes, setSubCaste] = useState([]);
    const [contrys,setCountrys]=useState([])
    const [errors, setErrors] = useState({});

    const validateForm = (state) => {
        const newErrors = {};
        let isValid = true;
    
        // Define base required fields excluding havingChildren
        const requiredFields = {
            // fullName: "Full Name",
            // surname: "Surname",
            // email: "Email",
            mobileNumber: "Mobile Number",
            gender: "Gender",
            dateOfBirth: "Date of Birth",
            timeOfBirth: "Time of Birth",
            birthPlace: "Birth Place",
            religion: "Religion",
            subcaste: "subCaste",
            country:"country",
            caste: "Caste",
            convertedCaste: "Converted Caste",
            gothram: "Gothram",
            khujaDosham: "Kuja Dosham",
            subcaste: "sub caste",
            height: "Height",
            bloodGroup: "Blood Group",
            motherTongue: "Mother Tongue",
            healthCondition: "Health Condition",
            complexion: "Complexion",
            maritalStatus: "Marital Status",
            smoke: "Smoke",
            drink: "Drink",
            food: "Food",
            selectedMusic: "Music Preferences",
            selectedHobbies: "Hobbies",
            city: "City",
            address: "Address",
            star: "Star",
            moonsign: "Moon Sign",
            handicappedInfo: "Handicapped Info",
            interests: "Interests",
            cuisines: "Cuisines",
            reads: "Reads",
            sports: "Sports",
            movies: "Movies",
            dressStyles: "Dress Styles",
            spokenLanguages: "Spoken Languages",
            applicationFor: "Application For",
            source: "Source",
            nearestBranch: "Nearest Branch",
        };
    
        // Validate all fields except havingChildren
        Object.entries(requiredFields).forEach(([field, label]) => {
            if (
                !state[field] ||
                (Array.isArray(state[field]) && state[field].length === 0) ||
                state[field] === "" ||
                state[field] === null
            ) {
                newErrors[field] = `${label} must be selected`;
                isValid = false;
            }
        });
    
        // Only validate havingChildren if marital status is not Single
        if (state.maritalStatus && state.maritalStatus !== "Single") {
            if (state.havingChildren !== 0 && state.havingChildren !== 1) {
                newErrors.havingChildren = "Having Children must be selected";
                isValid = false;
            }
        }
    
        // Special validations
        if (state.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
            newErrors.email = "Please enter a valid email address";
            isValid = false;
        }
    
        // if (state.mobileNumber && !/^\d{10}$/.test(state.mobileNumber)) {
        // 	newErrors.mobileNumber = "Please enter a valid 10-digit mobile number";
        // 	isValid = false;
        // }
    
        if (
            state.alternativeEmail &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.alternativeEmail)
        ) {
            newErrors.alternativeEmail = "Please enter a valid email address";
            isValid = false;
        }
        if (state.pincode && !/^\d{6}$/.test(state.pincode)) {
            newErrors.pincode = "Please enter a valid 6-digit mobile number";
            isValid = false;
        }
    
    
        if (state.alternativeMobile && !/^\d{10}$/.test(state.alternativeMobile)) {
            newErrors.alternativeMobile = "Please enter a valid 10-digit mobile number";
            isValid = false;
        }
    
        // Add validation for application filling person details
        if (state.applicationFor && state.applicationFor !== "Myself") {
            if (!state.applicationFillingPersonName) {
                newErrors.applicationFillingPersonName =
                    "Application filling person name is required";
                isValid = false;
            }
            if (!state.applicationFillingPersonMobile) {
                newErrors.applicationFillingPersonMobile = "Mobile number is required";
            } else if (!/^\d{10}$/.test(state.applicationFillingPersonMobile)) {
                newErrors.applicationFillingPersonMobile =
                    "Enter valid 10-digit mobile number";
                isValid = false;
            }
        }
        setErrors(newErrors);
            // return Object.keys(newErrors).length === 0;
    
        return { isValid, errors };
    };
    let userType = sessionStorage.getItem("userType")
	let token
	if(userType){
		token = sessionStorage.getItem("token");
	}else{
		 token = localStorage.getItem("token");
	}
    const fetchCities = async (id) => {
        try {
            const response = await getCitiesListByCountry(id);
            if (response.status) {
                setCities(response.data);
            } else {
                console.error("Failed to fetch cities:", response.message);
                setCities([]);
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };
    useEffect(() => {
        

        const fetchCountry=async()=>{
            try{
                const response=await getCountriesList();
                if(response.status){
                    setCountrys(response.data);
                }else{
                    console.log("Failed to fetch country:", response.message);
                }
            }catch(error){
                console.error("Error fetching country:", error);				
            }
        }
        const fetchReligions = async () => {
            try {
                const response = await getReligionsList();
                if (response.status) {
                    setReligions(response.data);
                }
            } catch (error) {
                console.error("Error fetching religions:", error);
            }
        };

        const fetchCastes = async () => {
            try {
                const response = await getCastesList();
                if (response.status) {
                    setCastes(response.data);
                }
            } catch (error) {
                console.error("Error fetching castes:", error);
            }
        };
        
        const fetchMusic = async () => {
            try {
                const response = await getMusicList();
                if (response.status) {
                    setMusicList(response.data);
                }
            } catch (error) {
                console.error("Error fetching music preferences:", error);
            }
        };

        const fetchHobbies = async () => {
            try {
                const response = await getHobbiesList();
                if (response.status) {
                    setHobbies(response.data);
                }
            } catch (error) {
                console.error("Error fetching hobbies:", error);
            }
        };

        const fetchMotherTongue = async () => {
            try {
                const response = await getMotherTongueList();
                if (response.status) {
                    setMotherTongueList(response.data);
                }
            } catch (error) {
                console.error("Error fetching mother tongue list:", error);
            }
        };

        const fetchStarAndMoonsign = async () => {
            try {
                const [starResponse, moonsignResponse] = await Promise.all([
                    getStarList(),
                    getMoonsignList(),
                ]);
                if (starResponse.status) setStarList(starResponse.data);
                if (moonsignResponse.status) setMoonsignList(moonsignResponse.data);
            } catch (error) {
                console.error("Error fetching star/moonsign data:", error);
            }
        };

        const fetchAdditionalLists = async () => {
            try {
                const [
                    interestsRes,
                    cuisineRes,
                    readsRes,
                    sportsRes,
                    moviesRes,
                    dressStyleRes,
                ] = await Promise.all([
                    getInterestsList(),
                    getCuisineList(),
                    getReadsList(),
                    getSportsList(),
                    getMoviesList(),
                    getDressStyleList(),
                ]);

                if (interestsRes.status) setInterestsList(interestsRes.data);
                if (cuisineRes.status) setCuisineList(cuisineRes.data);
                if (readsRes.status) setReadsList(readsRes.data);
                if (sportsRes.status) setSportsList(sportsRes.data);
                if (moviesRes.status) setMoviesList(moviesRes.data);
                if (dressStyleRes.status) setDressStyleList(dressStyleRes.data);
            } catch (error) {
                console.error("Error fetching additional lists:", error);
            }
        };

        const fetchAdditionalData = async () => {
            try {
                const [
                    readsResponse,
                    languageResponse,
                    applicationForResponse,
                    sourceResponse,
                    branchResponse,
                    healthConditionResponse,
                ] = await Promise.all([
                    getReadsList(),
                    getLanguageList(),
                    getApplicationForList(),
                    getSourceList(),
                    getNearestBranchList(),
                    getHealthConditionList(),
                ]);

                if (readsResponse.status) setReadsList(readsResponse.data);
                if (languageResponse.status) setLanguageList(languageResponse.data);
                if (applicationForResponse.status)
                    setApplicationForList(applicationForResponse.data);
                if (sourceResponse.status) setSourceList(sourceResponse.data);
                if (branchResponse.status) setBranchList(branchResponse.data);
                if (healthConditionResponse.status) {
                    setHealthConditionList(healthConditionResponse.data);
                }
            } catch (error) {
                console.error("Error fetching additional data:", error);
            }
        };

        const fetchProfileAndPreFill = async () => {
            try {
                const profileData = await getProfileDetails();
                if (profileData.status && profileData.data) {
                    const data = profileData.data;
                    dispatch({
                        type: "SET_FIELD",
                        field: "fullName",
                        value: data.fullname || "",
                    });
                    // Continue setting other fields...
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

        if (token) {
            fetchCities();
            fetchReligions();
            fetchCastes();
            // fetchSubCaste();
            fetchMusic();
            fetchHobbies();
            fetchMotherTongue();
            fetchStarAndMoonsign();
            fetchAdditionalLists();
            fetchAdditionalData();
            fetchProfileAndPreFill();
            fetchCountry();
        }
    }, []);
    const fetchSubCaste = async (id) => {
            try {
                const response = await getSubCatesList(id);
                if (response.status) {
                    setSubCaste(response.data);
                }else{
                    setSubCaste([]);
                }
            } catch (error) {
                console.error("Error fetching subcastes:", error);

            }
        };
    useEffect(() => {
        const fetchAndPopulateData = async () => {
            try {
                const response = await getProfileDetails();
                if (response.status && response.data?.personalDetails) {
                    const data = response.data.personalDetails;
                    console.log("Profile Data:", data);

                    // Basic Personal Details
                    dispatch({
                        type: "SET_FIELD",
                        field: "fullName",
                        value: data.fullname || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "surname",
                        value: data.surname || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "email",
                        value: data.email || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "mobileNumber",
                        value: data.mobileNumber || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "gender",
                        value: data.gender?.toLowerCase() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "address",
                        value: data.address || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "birthPlace",
                        value: data.birthPlace || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "gothram",
                        value: data.gothram || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "aadharNumber",
                        value: data.aadharNumber || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "alternativeEmail",
                        value: data.alternateEmail || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "alternativeMobile",
                        value: data.alternateMobile || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "applicationFor",
                        value: data.applicationFor || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "pincode",
                        value: data.pincode || "",
                    });

                    // Dates
                    if (data.liveWithFamily) {
                        
                        dispatch({
                            type: "SET_FIELD",
                            field: "livewithfamliy",
                            value: data.liveWithFamily || null,
                        });
                    }

                    if (data.diet) {
                        
                        dispatch({
                            type: "SET_FIELD",
                            field: "diet",
                            value: data.diet || null,
                        });
                    }
                    if (data.dateOfBirth) {
                        dayjs.extend(utc);
                        dispatch({
                            type: "SET_FIELD",
                            field: "dateOfBirth",
                            value: dayjs.utc(data.dateOfBirth).local(),
                        });
                    }

                    if (data.dateOfDivorce) {
                        dayjs.extend(utc);
                        dispatch({
                            type: "SET_FIELD",
                            field: "dateOfDivorce",
                            value: dayjs.utc(data.dateOfDivorce).local(),
                        });
                    }

                    if (data.dateOfDeath) {
                        dayjs.extend(utc);
                        dispatch({
                            type: "SET_FIELD",
                            field: "dateOfDeath",
                            value: dayjs.utc(data.dateOfDeath).local(),
                        });
                    }

                    if (data.dateOfMarriage) {
                        dayjs.extend(utc);
                        dispatch({
                            type: "SET_FIELD",
                            field: "dateOfMarriage",
                            value: dayjs.utc(data.dateOfMarriage).local(),
                        });
                    }
                    if (data.timeOfBirth) {
                        dispatch({
                            type: "SET_FIELD",
                            field: "timeOfBirth",
                            value: dayjs(data.timeOfBirth, "HH:mm"),
                        });
                    }
                    if (data.timeToCall) {
                        dispatch({
                            type: "SET_FIELD",
                            field: "timeToCall",
                            value: dayjs(data.timeToCall, "HH:mm"),
                        });
                    }

                    // Object fields that need to be found from lists
                    if (data.religion) {
                        const religion = religions.find((r) => r.id === data.religion);
                        dispatch({
                            type: "SET_FIELD",
                            field: "religion",
                            value: religion || null,
                        });
                    }

                    if (data.city) {
                        const city =cities.find((c) => c.id === data.city);
                        dispatch({
                            type: "SET_FIELD",
                            field: "city",
                            value: city || null,
                        });
                    }
                    
                    if (data.country) {
                        const country =contrys.find((c) => c.id == data.country);
                        dispatch({
                            type:"SET_FIELD",
                            field:"country",
                            value:country || null,
                        });

                        await fetchCities(country.id)
                    }
                    if (data.subCaste) {
                        const subcaste = subcastes.find((s) => s.id == data.subCaste);
                        dispatch({
                            type: "SET_FIELD",
                            field: "subcaste",
                            value: subcaste || null,
                        });
                    }
                    if (data.caste) {
                        const caste = castes.find((c) => c.id == data.caste);
                        dispatch({
                            type: "SET_FIELD",
                            field: "caste",
                            value: caste || null,
                        });
                        await fetchSubCaste(caste.id)
                    }

                    if (data.motherTongue) {
                        const motherTongue = motherTongueList.find(
                            (mt) => mt.id === data.motherTongue
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "motherTongue",
                            value: motherTongue?.id || "",
                        });
                    }

                    if (data.star) {
                        const star = starList.find((s) => s.id === data.star);
                        dispatch({ type: "SET_FIELD", field: "star", value: star || null });
                    }

                    if (data.moonsign) {
                        const moonsign = moonsignList.find((m) => m.id === data.moonsign);
                        dispatch({
                            type: "SET_FIELD",
                            field: "moonsign",
                            value: moonsign || null,
                        });
                    }

                    // Health Condition
                    if (data.healthCondition) {
                        dispatch({
                            type: "SET_FIELD",
                            field: "healthCondition",
                            value: data.healthCondition,
                        });
                    }

                    if (data.reasonForDivorce) {
                        dispatch({
                            type: "SET_FIELD",
                            field: "reasonForDivorce",
                            value: data.reasonForDivorce,
                        });
                    }
                    

                    
                    dispatch({
                        type: "SET_FIELD",
                        field: "khujaDosham",
                        value: data.khujaDosham ? "yes" : "no",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "height",
                        value: data.height?.toString() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "bloodGroup",
                        value: data.bloodGroup || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "complexion",
                        value: data.complexion?.toLowerCase() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "maritalStatus",
                        value: data.maritalStatus || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "havingChildren",
                        value: data.havingChildren,
                    });
                    
                    dispatch({
                        type: "SET_FIELD",
                        field: "smoke",
                        value: data.smoke?.toLowerCase() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "drink",
                        value: data.drink?.toLowerCase() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "food",
                        value: data.food?.toString() || "",
                    });
                    dispatch({
                        type: "SET_FIELD",
                        field: "handicappedInfo",
                        value: data.handicappedInfo || "",
                    });

                    // Array fields
                    if (data.hobbies && Array.isArray(data.hobbies)) {
                        const selectedHobbies = hobbies.filter((h) =>
                            data.hobbies.includes(String(h.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "selectedHobbies",
                            value: selectedHobbies,
                        });
                    }

                    if (data.sports && Array.isArray(data.sports)) {
                        const selectedSports = sportsList.filter((s) =>
                            data.sports.includes(String(s.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "sports",
                            value: selectedSports,
                        });
                    }

                    if (data.favouriteCuisine && Array.isArray(data.favouriteCuisine)) {
                        const selectedCuisines = cuisineList.filter((c) =>
                            data.favouriteCuisine.includes(String(c.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "cuisines",
                            value: selectedCuisines,
                        });
                    }

                    if (data.favouriteMusic && Array.isArray(data.favouriteMusic)) {
                        const selectedMusic = musicList.find((m) =>
                            data.favouriteMusic.includes(String(m.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "selectedMusic",
                            value: selectedMusic || null,
                        });
                    }

                    if (data.favouriteReads && Array.isArray(data.favouriteReads)) {
                        const selectedReads = readsList.filter((r) =>
                            data.favouriteReads.includes(String(r.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "favouriteReads",
                            value: selectedReads,
                        });
                    }

                    if (data.preferredMovies && Array.isArray(data.preferredMovies)) {
                        const selectedMovies = moviesList.filter((movie) =>
                            data.preferredMovies.some(
                                (id) =>
                                    String(id) === String(movie.id) || String(id) === String("0")
                            )
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "movies",
                            value: selectedMovies,
                        });
                    }

                    if (
                        data.preferredDressStyle &&
                        Array.isArray(data.preferredDressStyle)
                    ) {
                        const selectedDressStyles = dressStyleList.filter((style) =>
                            data.preferredDressStyle.some(
                                (id) =>
                                    String(id) === String(style.id) || String(id) === String("0")
                            )
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "dressStyles",
                            value: selectedDressStyles,
                        });
                    }

                    if (data.spokenLanguages && Array.isArray(data.spokenLanguages)) {
                        const selectedLanguages = languageList.filter((l) =>
                            data.spokenLanguages.includes(String(l.id))
                        );
                        dispatch({
                            type: "SET_FIELD",
                            field: "spokenLanguages",
                            value: selectedLanguages,
                        });
                    }

                    
                    if (data.source) {
                        const source = sourceList.find((s) => s.id === data.source);
                        dispatch({ type: "SET_FIELD", field: "source", value: source });
                    }

                    if (data.nearestBranch) {
                        const branch = branchList.find((b) => b.id === data.nearestBranch);
                        dispatch({
                            type: "SET_FIELD",
                            field: "nearestBranch",
                            value: branch,
                        });
                    }

                    console.log("State after population:", state);
                }
            } catch (error) {
                console.error("Error fetching profile data:", error);
            }
        };

        // Only fetch if all required lists are loaded
        if (
            token &&
            dressStyleList.length &&
            motherTongueList.length &&
            religions.length &&
            contrys.length&&
            cities.length &&
            subcastes.length &&
            castes.length &&
            starList.length &&
            moonsignList.length &&
            healthConditionList.length &&
            moviesList.length
        ) {
            fetchAndPopulateData();
        }
    }, [
        dressStyleList,
        motherTongueList,
        contrys,
        religions,
        cities,
        subcastes,
        castes,
        starList,
        moonsignList,
        healthConditionList,
        musicList,
        hobbies,
        sportsList,
        cuisineList,
        readsList,
        moviesList,
        languageList,
        sourceList,
        branchList,
    ]);

    const handleCityChange = async (event, newValue) => {
        if (newValue) {
            try {
                const response = await getCitiesList("", true);
                const cityDetails = response.data.find(
                    (city) => city.id === newValue.id
                );
                if (cityDetails) {
                    dispatch({
                        type: "SET_LOCATION",
                        value: {
                            cityId: cityDetails.id,
                            cityName: cityDetails.cityName,
                            districtName: cityDetails.district?.districtName || "",
                            stateName: cityDetails.state?.stateName || "",
                            countryName: cityDetails.country?.countryName || "",
                            countryId: cityDetails.country?.id,
                            stateId: cityDetails.state?.id,
                            districtId: cityDetails.district?.id,
                        },
                    });
                }
            } catch (error) {
                console.error("Error fetching city details:", error);
            }
        }
    };

    const handleContinue = async () => {
        try {
            setFormData("personal", state);
            let newFormData ={
                "dateOfBirth": state?.dateOfBirth,
                "religion": state.religion?.id || null,
                "caste":state.caste?.id || null,
                "subCaste": state.subcaste?.id|| null,
                "maritalStatus":state.maritalStatus ? state.maritalStatus
                            : null,
                "liveWithFamily": state.livewithfamliy || null,
                "diet": state.diet,
                "havingChildren": state.maritalStatus === "Single" ? 0 : state.havingChildren,
                "dateOfMarriage": state.dateOfMarriage || null,
                "dateOfDeath":state.dateOfDeath || null,
                "dateOfDivorce": state.dateOfDivorce || null,
                "reasonForDivorce": state.maritalStatus === "Divorced" ? state.reasonForDivorce : null,
                "country": state.country?.id || null,
                "city" : state.city?.id || 0,
                "noOfChildren" : state?.noOfChildren,
                "childrensData" : state?.childrenInfo ? state?.childrenInfo : []
              }
            const response = await updatePersonalDetails(newFormData);

            if (!response.status) {
                setAlert({
                    open: true,
                    message: response.message,
                    severity: "error",
                });
                return;
            }

            setAlert({
                open: true,
                message: "Personal details updated successfully",
                severity: "success",
            });

            const profileData = await getProfileDetails();
            if (profileData.status) {
                localStorage.setItem("profileData", JSON.stringify(profileData.data));
            }

            setTimeout(() => {
                navigate("/profile/education");
            }, 1000);
        } catch (error) {
            setAlert({
                open: true,
                message: error.message || "Failed to update personal details",
                severity: "error",
            });
        }
    };

    const renderMaritalStatusFields = () => {
        const status = state.maritalStatus;
        return (
            <>
                {status && status !== "Single" && (
                    <StyledFormControl fullWidth size="small">
                        <InputLabel>Having Children</InputLabel>
                        <Select
                            value={state.havingChildren}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "havingChildren",
                                    value: e.target.value,
                                })
                            }
                            label="Having Children"
                        >
                            <MenuItem value={1}>Yes</MenuItem>
                            <MenuItem value={0}>No</MenuItem>
                        </Select>
                    </StyledFormControl>
                )}

                {state.havingChildren == 1 && (
                <>
                    {/* No. of Children Selector */}
                    <StyledFormControl fullWidth size="small">
                    <InputLabel>No of Children</InputLabel>
                    <Select
                        value={state.noOfChildren}
                        onChange={(e) =>
                        dispatch({
                            type: "SET_FIELD",
                            field: "noOfChildren",
                            value: e.target.value,
                        })
                        }
                        label="No of Children"
                    >
                        {[1, 2, 3, 4, 5, 6].map((num) => (
                        <MenuItem key={num} value={num}>
                            {num}
                        </MenuItem>
                        ))}
                    </Select>
                    </StyledFormControl>

                    {/* Children Info Fields */}
                    {Array.from({ length: state.noOfChildren || 0 }, (_, index) => (
                    <div key={index} style={{ marginTop: "1rem", padding: "1rem", border: "1px solid #ccc", borderRadius: "8px" }}>
                        <h4>Child {index + 1}</h4>

                        {/* Gender */}
                        <StyledFormControl fullWidth size="small" style={{ marginBottom: "0.5rem" }}>
                        <InputLabel>Gender</InputLabel>
                        <Select
                            value={state.childrenInfo?.[index]?.gender || ""}
                            onChange={(e) =>
                            dispatch({
                                type: "SET_CHILD_INFO",
                                index,
                                field: "gender",
                                value: e.target.value,
                            })
                            }
                            label="Gender"
                        >
                            <MenuItem value="">Select Gender</MenuItem>
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        </StyledFormControl>

                        {/* Age */}
                        <StyledTextField
                        fullWidth
                        size="small"
                        label="Age"
                        type="number"
                        inputProps={{ min: 0 }}
                        value={state.childrenInfo?.[index]?.age || ""}
                        onChange={(e) =>
                            dispatch({
                            type: "SET_CHILD_INFO",
                            index,
                            field: "age",
                            value: e.target.value,
                            })
                        }
                        style={{ marginBottom: "0.5rem" }}
                        />

                        {/* Dependent On */}
                        <StyledFormControl fullWidth size="small">
                        <InputLabel>Dependent On</InputLabel>
                        <Select
                            value={state.childrenInfo?.[index]?.dependentOn || ""}
                            onChange={(e) =>
                            dispatch({
                                type: "SET_CHILD_INFO",
                                index,
                                field: "dependentOn",
                                value: e.target.value,
                            })
                            }
                            label="Dependent On"
                        >
                            <MenuItem value="Father">Father</MenuItem>
                            <MenuItem value="Mother">Mother</MenuItem>
                            <MenuItem value="Individual">Individual</MenuItem>
                            <MenuItem value="Both">Both</MenuItem>
                        </Select>
                        </StyledFormControl>
                    </div>
                    ))}
                </>
                )}

                {(status === "Widower" ||
                    status === "Divorced" ||
                    status === "Waiting for Divorce") && (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date of Marriage"
                                value={state.dateOfMarriage}
                                onChange={(newValue) =>
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "dateOfMarriage",
                                        value: newValue,
                                    })
                                }
                                renderInput={(params) => (
                                    <StyledTextField {...params} fullWidth size="small" />
                                )}
                            />
                        </LocalizationProvider>
                    )}

                {status === "Widower" && (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date of Death"
                                value={state.dateOfDeath}
                                onChange={(newValue) =>
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "dateOfDeath",
                                        value: newValue,
                                    })
                                }
                                renderInput={(params) => (
                                    <StyledTextField {...params} fullWidth size="small" />
                                )}
                            />
                        </LocalizationProvider>
                        <StyledTextField
                            type="file"
                            fullWidth
                            label="Death Certificate"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "deathCertificate",
                                    value: e.target.files[0],
                                })
                            }
                            size="small"
                        />
                    </>
                )}

                {status === "Divorced" && (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date of Divorce"
                                value={state.dateOfDivorce}
                                onChange={(newValue) =>
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "dateOfDivorce",
                                        value: newValue,
                                    })
                                }
                                renderInput={(params) => (
                                    <StyledTextField {...params} fullWidth size="small" />
                                )}
                            />
                        </LocalizationProvider>
                        <StyledTextField
                            type="file"
                            fullWidth
                            label="Divorce Certificate"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "divorceCertificate",
                                    value: e.target.files[0],
                                })
                            }
                            size="small"
                        />
                        <StyledTextField
                            fullWidth
                            label="Reason for Divorce"
                            value={state.reasonForDivorce}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "reasonForDivorce",
                                    value: e.target.value,
                                })
                            }
                            multiline
                            rows={4}
                            size="small"
                        />
                    </>
                )}
            </>
        );
    };

    return (
        <Container maxWidth={false} sx={{ maxWidth: "none" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                    px: { xs: 0, sm: 25 },
                    py: { xs: 2 }
                }}
            >
                <Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
                    <img
                        src="/images/Frame 148.png"
                        alt="Logo"
                        style={{
                            maxWidth: "330px",
                            width: "100%",
                            height: "auto",
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        position: "relative",
                        width: 180,
                        height: 180,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress
                        variant="determinate"
                        value={100}
                        size={120}
                        thickness={3}
                        sx={{
                            position: "absolute",
                            color: "#F0E0D0",
                        }}
                    />
                    <CircularProgress
                        variant="determinate"
                        value={75}
                        size={120}
                        thickness={3}
                        sx={{
                            position: "absolute",
                            color: "#B56E2C",
                        }}
                    />
                    <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>20%</Typography>
                        <Typography sx={{ color: "#B56E2C" }}>completed</Typography>
                    </Box>
                </Box>
            </Box>
            <FormContainer elevation={0} sx={{ ...styles.formCard }}>
                <DecorativeCorner
                    sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
                />
                <DecorativeCorner
                    sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
                />
                <DecorativeCorner
                    sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
                />
                <DecorativeCorner
                    sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
                />
                <div className="form-content">
                    <SectionTitle style={styles.formTitle} variant="h6">
                        Personal Details
                    </SectionTitle>

                    <FormGrid>

                    <StyledTextField
                        fullWidth
                        label="Date Of Birth"
                        type="date"
                        value={
                            state.dateOfBirth
                            ? new Date(state.dateOfBirth).toISOString().slice(0, 10)
                            : ""
                        }
                        onChange={(e) =>
                            dispatch({
                            type: "SET_FIELD",
                            field: "dateOfBirth",
                            value: e.target.value,
                            })
                        }
                        error={!!state.errors.dateOfBirth}
                        helperText={state.errors.dateOfBirth}
                        size="small"
                        inputProps={{
                            max: new Date(
                            new Date().setFullYear(new Date().getFullYear() - 18)
                            )
                            .toISOString()
                            .slice(0, 10),
                        }}
                        />

                        <Autocomplete
                            options={religions}
                            getOptionLabel={(option) => option.religionName}
                            value={state.religion}
                            onChange={(event, newValue) => {
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "religion",
                                    value: newValue,
                                });
                            }}
                            renderInput={(params) => (
                                <StyledTextField
                                    {...params}
                                    label="Religion"
                                    variant="outlined"
                                    size="small"
                                    error={!!state.errors.religion}
                                    helperText={state.errors.religion}
                                />
                            )}
                        />

                        <Autocomplete
                            options={castes}
                            getOptionLabel={(option) => option.castName || ""}
                            value={state.caste}
                            onChange={async(event, newValue) => {
                                dispatch({
                                    type: "SET_FIELD",
                                    field: "caste",
                                    value: newValue,
                                });
                                if(newValue){
                                    await fetchSubCaste(newValue.id)
                                }
        
                            }}
                            renderInput={(params) => (
                                <StyledTextField
                                    {...params}
                                    label="caste"
                                    variant="outlined"
                                    size="small"
                                    error={!!state.errors.caste}
                                    helperText={state.errors.caste}
                                />
                            )}
                        />
                            <Autocomplete
                                options={subcastes}
                                getOptionLabel={(option) => option.castName}
                                value={state.subcaste}
                                onChange={(event, newValue) => {
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "subcaste",
                                        value: newValue,
                                    });
                                }}
                                renderInput={(params) => (
                                    <StyledTextField
                                        {...params}
                                        label="subcaste"
                                        variant="outlined"
                                        size="small"
                                        error={!!state.errors.subcaste}
                                        helperText={state.errors.subcaste}
                                    />
                                )}
                            />
                    <Autocomplete
                            options={contrys}
                            getOptionLabel={(option) => option.countryName}
                            value={state.country}
                            onChange={async(event, newValue) => {
                                dispatch({
                                    type: "SET_FIELD",
                                    field:"country",
                                    value: newValue,
                                });
                                if(newValue){
                                    await fetchCities(newValue.id)
                                }
                            }}
                            renderInput={(params) => (
                                <StyledTextField
                                    {...params}
                                    label="country"
                                    variant="outlined"
                                    size="small"
                                    error={!!state.errors.country}
                                    helperText={state.errors.country}
                                />
                            )}
                        />

                        <Autocomplete
                            options={cities}
                            getOptionLabel={(option) => option.cityName}
                            value={state.city}
                            onChange={(event, newValue) => {
                                dispatch({
                                    type: "SET_FIELD",
                                    field:"city",
                                    value:newValue,
                                });
                            }}
                            renderInput={(params) => (
                                <StyledTextField
                                    {...params}
                                    label="city"
                                    variant="outlined"
                                    size="small"
                                    error={!!state.errors.city}
                                    helperText={state.errors.city}
                                />
                            )}
                        />

                        <StyledFormControl fullWidth size="small">
                            <InputLabel id="Do you live with your family-dosham-label">Do you live with your family</InputLabel>
                            <Select
                                labelId="Do you live with your family-dosham-label"
                                label="Do you live with your family"
                                value={state.livewithfamliy || ""}
                                onChange={(e) =>
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "livewithfamliy",
                                        value: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                                <MenuItem value="Dont Know">Don't Know</MenuItem>
                            </Select>
                        </StyledFormControl>

                        <StyledFormControl
                            fullWidth
                            size="small"
                            error={!!state.errors.maritalStatus}
                        >
                            <InputLabel>Marital Status</InputLabel>
                            <Select
                                label="Marital Status"
                                value={state.maritalStatus}
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "maritalStatus",
                                        value: newValue,
                                    });
                                    if (newValue === "Single") {
                                        // Reset related fields
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "havingChildren",
                                            value: "",
                                        });
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "dateOfMarriage",
                                            value: null,
                                        });
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "dateOfDeath",
                                            value: null,
                                        });
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "dateOfDivorce",
                                            value: null,
                                        });
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "deathCertificate",
                                            value: null,
                                        });
                                        dispatch({
                                            type: "SET_FIELD",
                                            field: "divorceCertificate",
                                            value: null,
                                        });
                                    }
                                }}
                            // label="Marital Status"
                            >
                                <MenuItem value="Single">Never married</MenuItem>
                                <MenuItem value="Divorced">Divorced</MenuItem>
                                <MenuItem value="Widower">Widower</MenuItem>
                                <MenuItem value="Waiting for Divorce">
                                    Waiting for Divorce
                                </MenuItem>
                            </Select>
                            {state.errors.maritalStatus && (
                                <FormHelperText>{state.errors.maritalStatus}</FormHelperText>
                            )}
                        </StyledFormControl>

                        {renderMaritalStatusFields()}
                        <StyledFormControl fullWidth size="small">
                            <InputLabel id="Your Diet-dosham-label">Your Diet</InputLabel>
                            <Select
                                labelId="Your Diet-dosham-label"
                                label="Your Diet"
                                value={state.diet || ""}
                                onChange={(e) =>
                                    dispatch({
                                        type: "SET_FIELD",
                                        field: "diet",
                                        value: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="Veg">Veg</MenuItem>
                                <MenuItem value="Non-Veg">Non-Veg</MenuItem>
                                <MenuItem value="Both">Both</MenuItem>
                                <MenuItem value="Eggetarain">Eggetarain</MenuItem>
                            </Select>
                        </StyledFormControl>
                    </FormGrid>
                    <CustomAlert
                        open={alert.open}
                        message={alert.message}
                        severity={alert.severity}
                        onClose={() => setAlert({ ...alert, open: false })}
                    />
                    <StyledButton
                        variant="contained"
                        onClick={handleContinue}
                        sx={{
                            width: { xs: "100%", sm: "160px" },
                            marginTop: { xs: 3, md: 4 },
                            padding: "15px 0px",
                        }}
                    >
                        Save & Continue
                    </StyledButton>
                </div>
            </FormContainer>
        </Container>
    );
};

export default PersonalDetailsForm;
